module.exports = __webpack_public_path__ + "img/ico_carousel.c602dd44.png";